module.exports = __webpack_public_path__ + "img/1603570161_avatar2.b2fd00c9.jpg";